import React, { useState, useEffect } from 'react';

const FpsCounter = () => {
    const [fps, setFps] = useState(60);

    useEffect(() => {
        let frameCount = 0;
        let lastTime = performance.now();
        let animationFrameId = null;

        const updateFps = () => {
            frameCount++;
            const now = performance.now();
            if (now - lastTime >= 1000) {
                setFps(Math.round((frameCount * 1000) / (now - lastTime)));
                frameCount = 0;
                lastTime = now;
            }
            animationFrameId = requestAnimationFrame(updateFps);
        };

        animationFrameId = requestAnimationFrame(updateFps);

        return () => {
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <div className="fixed bottom-4 left-4 z-[99999] px-3 py-1 bg-black/60 dark:bg-slate-900/80 backdrop-blur-md border border-white/10 dark:border-slate-800/50 rounded-full text-[10px] font-bold text-emerald-400 dark:text-emerald-400 shadow-md select-none pointer-events-none transition-colors duration-300">
            FPS: {fps}
        </div>
    );
};

export default FpsCounter;
